<template>
  <div>
    <panel no-button="true" :title="'Import' + categoryType + ' categories'">
      <div class="form-group row m-b-15">
        <label class="col-form-label col-md-3"
          >Import file (xlsx, xls, csv)</label
        >
        <div class="col-md-9">
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="handleFile"
          />
        </div>
      </div>
      <div v-if="file">
        <hr />
        <b-overlay :show="isLoading" rounded="sm">
          <div v-if="multipleSheets" class="form-group row m-b-15">
            <label class="col-form-label col-md-3">Select sheet</label>
            <div class="col-md-9">
              <select
                v-model="selectedSheetName"
                class="form-control"
                @change="selectSheet"
              >
                <option value="null" selected disabled>Select sheet</option>
                <option
                  v-for="(sheet, index) in Object.keys(workbook.Sheets)"
                  :key="index"
                  :value="sheet"
                >
                  {{ sheet }}
                </option>
              </select>
              <p v-if="selectedSheetName && !headers.length" class="text-red">
                This sheet is empty!
              </p>
            </div>
          </div>
          <div v-if="selectedSheet">
            <div class="form-group row m-b-15">
              <label class="col-form-label col-md-3">Name column</label>
              <div class="col-md-9">
                <select v-model="nameColumn" class="form-control">
                  <option value="disabled" selected disabled>
                    Select column
                  </option>
                  <option value="null">None</option>
                  <option
                    v-for="(header, index) in headers"
                    :key="index"
                    :value="header"
                  >
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="!typeId" class="form-group row m-b-15">
              <label class="col-form-label col-md-3">Type column</label>
              <div class="col-md-9">
                <select v-model="typeColumn" class="form-control">
                  <option value="disabled" selected disabled>
                    Select column
                  </option>
                  <option value="null">None</option>
                  <option
                    v-for="(header, index) in headers"
                    :key="index"
                    :value="header"
                  >
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row m-b-15">
              <label class="col-form-label col-md-3"
                >Parent category column</label
              >
              <div class="col-md-9">
                <select v-model="parentColumn" class="form-control">
                  <option value="disabled" selected disabled>
                    Select column
                  </option>
                  <option value="null">None</option>
                  <option
                    v-for="(header, index) in headers"
                    :key="index"
                    :value="header"
                  >
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-group row m-b-15">
              <label class="col-form-label col-md-3">Description column</label>
              <div class="col-md-9">
                <select v-model="descriptionColumn" class="form-control">
                  <option value="disabled" selected disabled>
                    Select column
                  </option>
                  <option value="null">None</option>
                  <option
                    v-for="(header, index) in headers"
                    :key="index"
                    :value="header"
                  >
                    {{ header }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>

      <hr />

      <url-button label="Back" :url="'/eventbank'" class="btn-secondary" />
      <input-button
        :disabled="
          !headers.length ||
          nameColumn == 'disabled' ||
          (typeColumn == 'disabled' && !typeId) ||
          parentColumn == 'disabled'
        "
        type="submit"
        label="Import"
        @click="validate"
        class="btn-yellow pull-right"
      />
    </panel>
    <div class="row">
      <div class="col-xl-8 col-lg-7 m-b-20">
        <b-card bg-variant="dark" text-variant="light" title="Tooltip">
          <b-card-text> Lorem ipsum dolor sit amet. </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-4 col-lg-5">
        <b-card
          bg-variant="dark"
          text-variant="light"
          title="Download excel template"
        >
          <a
            :href="template"
            target="_blank"
            class="btn btn-yellow text-black"
            :download="typeId ? 'category_import' : 'mixed_category_import'"
            >Download</a
          >
        </b-card>
      </div>
    </div>
    <b-modal
      ref="modalCategories"
      centered
      title="Categories imported"
      ok-only
      ok-variant="yellow"
      v-on:ok="close"
    >
      <div class="alert alert-secondary m-b-0">
        <h5><i class="fa fa-info-circle"></i>Categoriess imported!</h5>
        <p>Categories imported successfully!</p>
      </div>
      <div v-if="errors.length" class="alert alert-danger m-b-0 m-t-20">
        <h5><i class="fa fa-info-circle"></i>Invalid categories!</h5>
        <p>These categories were not imported!</p>
        <b-button variant="light" @click="toggleErrors">{{
          showErrors ? 'Hide errors' : 'Show errors'
        }}</b-button>
        <div class="mt-2" v-if="showErrors">
          <vue-custom-scrollbar v-if="errors.length > 15" class="height-sm">
            <ul>
              <li v-for="(error, index) in errors" :key="index">
                {{ error.error }}
              </li>
            </ul>
          </vue-custom-scrollbar>
          <div v-else>
            <ul>
              <li v-for="(error, index) in errors" :key="index">
                {{ error.error }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="modalError"
      centered
      title="Error!"
      ok-only
      ok-variant="yellow"
      v-on:ok="close"
    >
      <div class="alert alert-danger m-b-0">
        <h5><i class="fa fa-info-circle"></i>Error!</h5>
        <p>Import failed!</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import XLSX from 'xlsx'
import UrlButton from '../buttons/UrlButton.vue'
import InputButton from '../buttons/InputButton.vue'

export default {
  name: 'CategoryImport',
  props: ['typeId', 'activeEvent'],
  components: {
    UrlButton,
    InputButton
  },
  data() {
    return {
      validatedCategories: [],
      categoryType: '',
      file: null,
      isLoading: false,
      workbook: null,
      multipleSheets: false,
      selectedSheetName: null,
      selectedSheet: null,
      headers: [],
      nameColumn: 'disabled',
      typeColumn: 'disabled',
      parentColumn: 'disabled',
      descriptionColumn: 'disabled',
      index: 0,
      newMainCategories: [],
      newSubcategories: [],
      errors: [],
      showErrors: false,
      handling: false
    }
  },
  computed: {
    ...mapState('category', ['categories', 'template'])
  },
  methods: {
    ...mapActions('category', ['downloadTemplateFile', 'importCategories']),
    handleFile(e) {
      this.selectedSheetName = null
      this.headers = []
      this.isLoading = true
      let self = this
      let files = e.target.files,
        f = files[0]
      let reader = new FileReader()
      reader.onload = function (e) {
        let data = new Uint8Array(e.target.result)
        self.workbook = XLSX.read(data, { type: 'array' })
        if (self.workbook.SheetNames.length > 1) {
          self.multipleSheets = true
        } else {
          self.multipleSheets = false
          self.selectedSheetName = self.workbook.SheetNames[0]
          self.selectSheet()
        }
      }
      reader.readAsArrayBuffer(f)
      this.isLoading = false
    },
    selectSheet() {
      this.headers = []
      this.selectedSheet = this.workbook.Sheets[this.selectedSheetName]
      if (this.selectedSheet['!ref']) {
        let columnCount =
          XLSX.utils.decode_range(this.selectedSheet['!ref']).e.c + 1
        for (let i = 0; i < columnCount; ++i) {
          if (this.selectedSheet[`${XLSX.utils.encode_col(i)}1`]) {
            this.headers[i] =
              this.selectedSheet[`${XLSX.utils.encode_col(i)}1`].v
          }
        }
      }
    },
    validate() {
      this.handling = true
      this.validatedCategories = []
      let category = null
      if (this.selectedSheet['!ref']) {
        let rowCount =
          XLSX.utils.decode_range(this.selectedSheet['!ref']).e.r + 1
        let columnCount =
          XLSX.utils.decode_range(this.selectedSheet['!ref']).e.c + 1
        for (let i = 1; i < rowCount; ++i) {
          category = {
            name: null,
            type: null,
            parent: null,
            description: ''
          }
          for (let j = 0; j < columnCount; ++j) {
            switch (this.headers[j]) {
              case this.nameColumn:
                if (
                  this.selectedSheet[
                    `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                  ]
                ) {
                  category.name =
                    this.selectedSheet[
                      `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                    ].v
                }
                break
              case this.typeColumn:
                if (
                  this.selectedSheet[
                    `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                  ]
                ) {
                  category.type =
                    this.selectedSheet[
                      `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                    ].v
                  switch (category.type.toLowerCase()) {
                    case 'service':
                      category.type = 1
                      break
                    case 'space':
                      category.type = 2
                      break
                    case 'staff':
                      category.type = 3
                      break
                    case 'stuff':
                      category.type = 4
                      break
                    default:
                      category.type = null
                      break
                  }
                }
                break
              case this.parentColumn:
                if (
                  this.selectedSheet[
                    `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                  ]
                ) {
                  category.parent =
                    this.selectedSheet[
                      `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                    ].v
                }
                break
              case this.descriptionColumn:
                if (
                  this.selectedSheet[
                    `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                  ]
                ) {
                  category.description =
                    this.selectedSheet[
                      `${XLSX.utils.encode_col(j)}${XLSX.utils.encode_row(i)}`
                    ].v
                }
                break
              default:
                break
            }
          }
          this.validatedCategories.push(category)
        }
      }
      this.submitCategories()
    },
    submitCategories() {
      this.errors = []
      let importedCategories = []
      this.validatedCategories.forEach((category) => {
        if (!category.parent) {
          if (category.name) {
            if (!category.type) {
              category.type = this.typeId
            }
            if (category.type) {
              let children = []
              this.validatedCategories.forEach((childCategory) => {
                if (
                  childCategory.parent &&
                  childCategory.parent.length > 0 &&
                  category.name &&
                  category.name.length > 0 &&
                  childCategory.parent.trim().toLowerCase() ===
                    category.name.trim().toLowerCase()
                ) {
                  if (childCategory.name) {
                    children.push({
                      name: childCategory.name,
                      typeId: parseInt(category.type),
                      description: childCategory.description,
                      notes: [],
                      eventId: parseInt(this.activeEvent.id)
                    })
                  } else {
                    this.errors.push({
                      error:
                        'Child category in the row ' +
                        (this.index + 2) +
                        ' has no name!'
                    })
                  }
                }
              })

              importedCategories.push({
                name: category.name,
                children: children,
                typeId: parseInt(category.type),
                description: category.description,
                notes: [],
                eventId: parseInt(this.activeEvent.id)
              })
            } else {
              this.errors.push({
                error:
                  'Category in the row ' +
                  (this.index + 2) +
                  ' has invalid type! Possible child categories also skipped.'
              })
            }
          } else {
            this.errors.push({
              error: 'Category in the row ' + (this.index + 2) + ' has no name!'
            })
          }
        }
      })
      this.importCategories(importedCategories)
    },
    toggleErrors() {
      this.showErrors = !this.showErrors
    },
    close() {
      this.file = null
      this.nameColumn = 'disabled'
      this.typeColumn = 'disabled'
      this.parentColumn = 'disabled'
      this.descriptionColumn = 'disabled'
    },
    downloadTemplate() {
      if (this.typeId) {
        this.downloadTemplateFile(true)
      } else {
        this.downloadTemplateFile(false)
      }
    }
  },
  mounted() {
    if (!this.$route.params.type) {
      this.downloadTemplate()
    }
  },
  watch: {
    typeId: function () {
      this.downloadTemplate()
      switch (this.typeId) {
        case 1:
          this.categoryType = ' service'
          break
        case 2:
          this.categoryType = ' space'
          break
        case 3:
          this.categoryType = ' staff'
          break
        case 4:
          this.categoryType = ' stuff'
          break
        default:
          this.categoryType = ''
          break
      }
    },
    categories: function () {
      if (this.handling) {
        if (this.categories.length) {
          this.$refs['modalCategories'].show()
        } else {
          this.$refs['modalError'].show()
        }
        this.handling = false
      }
    }
  }
}
</script>
